<template>
  <div class="header-container">
    <div class="header">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
    import {Component, Vue} from "vue-property-decorator";

@Component
    export default class DefaultHeader extends Vue {
    }
</script>
